import { Injectable } from '@angular/core';
import { CreditInfo } from '@models/user/credit-info/credit-info';
import { EndpointParams } from '@models/utils/endpoint-params';
import { BehaviorSubject, Observable } from 'rxjs';

import { HttpService } from 'src/app/services/http.service';

@Injectable({
    providedIn: 'root'
})
export class CreditsInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private infoSubject = new BehaviorSubject<CreditInfo>({ amountCredits: 0 });
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);

    private dataStore: { info: CreditInfo } = { info: { amountCredits: 0 }};

    readonly info = this.infoSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    search(): void {
        this.loading(true);
        this.getInfo().subscribe(
            () => {
                this.next({ ...this.dataStore.info });
                this.loading(false);
            }
        );
    }

    private getInfo(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('member/info', this.defaultEndpointParams).subscribe(
                    data => {
                        this.dataStore.info = data;
                        observable.next(true);
                    },
                    () => observable.next(false)
                );
            }
        );
    }

    private next(data: CreditInfo): void {
        this.infoSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
